import React from 'react';
import { Link } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import Navbar from './Navbar';
import Footer from './Footer';
import Timelapse from './Timelapse';
import { AUTUMN_GUIDES, AUTUMN_INSTAGRAM, AUTUMN_VENMO, autumnGuidePath, autumnGuideUrl } from './autumnGuides';
import './Autumn.css';

const AutumnPage = () => {
  return (
    <div className="autumn-page">
      <Navbar />
      <Timelapse />
      <section className="autumn-qr-section">
        <div className="autumn-qr-container">
          <h1 className="autumn-qr-title">Autumn care guides</h1>
          <p className="autumn-qr-subtitle">
            Scan a code to open that plant’s care sheet.
          </p>
          <div className="autumn-qr-grid">
            {AUTUMN_GUIDES.map((guide) => (
              <Link
                key={guide.slug}
                className="autumn-qr-item"
                to={autumnGuidePath(guide.slug)}
              >
                <img
                  className="autumn-plant"
                  src={`/autumn/${guide.image}`}
                  alt=""
                />
                <span className="autumn-qr-body">
                  <QRCodeSVG
                    value={autumnGuideUrl(guide.slug)}
                    size={180}
                    level="M"
                    className="autumn-qr-code"
                    title={`${guide.label} care guide`}
                  />
                  <p>{guide.label}</p>
                </span>
              </Link>
            ))}
          </div>
          <div className="autumn-extra-codes">
            <a className="autumn-instagram" href={AUTUMN_INSTAGRAM}>
              <QRCodeSVG
                value={AUTUMN_INSTAGRAM}
                size={260}
                level="M"
                className="autumn-qr-code"
                title="Instagram"
              />
              <p>Instagram</p>
            </a>
            <a className="autumn-instagram" href={AUTUMN_VENMO}>
              <QRCodeSVG
                value={AUTUMN_VENMO}
                size={260}
                level="M"
                className="autumn-qr-code"
                title="Venmo"
              />
              <p>Venmo</p>
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AutumnPage;
